import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const NotFoundView = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: "center",
          maxWidth: 500,
          width: "100%",
        }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: 80,
            color: "error.main",
            marginBottom: 2,
          }}
        />
        
        <Typography variant="h3" component="h1" gutterBottom color="error">
          404
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you're looking for doesn't exist or you don't have access to it. 
          This could be because:
        </Typography>
        
        <Box sx={{ textAlign: "left", marginBottom: 3 }}>
          <Typography variant="body2" color="text.secondary">
            • The URL was typed incorrectly
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • The page has been moved or deleted
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • You don't have permission to access this page
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • Your session may have expired
          </Typography>
        </Box>
        
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoHome}
            sx={{ minWidth: 120 }}
          >
            Go Home
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleGoBack}
            sx={{ minWidth: 120 }}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFoundView;
